/**
 * Shared derivation for a FilterButton fed by a ChipFilterWithDropdown (exclusiveAll):
 * whether the filter counts as "active" (some but not all options selected), and what
 * label the button should show — the generic label when inactive, the single selected
 * option's own label when exactly one is picked, or a caller-supplied plural summary.
 */
export const getFilterButtonState = <T extends string>(
  options: { key: T; label: string }[],
  selected: T[],
  genericLabel: string,
  pluralLabel: (count: number) => string
): { selectedOptions: { key: T; label: string }[]; active: boolean; label: string } => {
  const selectedOptions = options.filter((o) => selected.includes(o.key));
  const active = selected.length > 0 && selected.length < options.length;
  const label = !active
    ? genericLabel
    : selected.length === 1
    ? selectedOptions[0]?.label || genericLabel
    : pluralLabel(selected.length);
  return { selectedOptions, active, label };
};
